
import {
    mapState,
    mapActions,
} from 'vuex'

export default {
    name: 'Swiper',
    props: {
        // 门店数据
        store: {
            type: Object,
            default: ''
        },
    },
    components: {
    },
    data () {
        return {

        }
    },
    computed: {
        ...mapState({

        }),
    },
    created () {

    },
    activated () {

    },
    mounted () {

    },
    methods: {
        ...mapActions([

        ]),

        onChange (index) {
        },
        callStore (type) {
            // lng: 经度
            // lat: 纬度
            const { mobile, lng, lat, sstore_name, sstore_address } = this.store
            if (type === 1) {
                window.location.href = 'tel://' + mobile
            } else if (type === 2) {
                window.location.href = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${sstore_name}&content=${sstore_address}&output=html&src=webapp.baidu.openAPIdemo`
            }
        }
    },
    destroyed () {

    }
}
